import { useSelector } from 'react-redux';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { styled } from '@mui/material/styles';
import en from '@emoji-mart/data/i18n/en.json';
import es from '@emoji-mart/data/i18n/es.json';
import pt from '@emoji-mart/data/i18n/pt.json';
import uk from '@emoji-mart/data/i18n/uk.json';
import Popper from '@components/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { LANGUAGE } from '@constants/language';

const PickerWrapper = styled('div')({
    '& em-emoji-picker': {
        '--font-family': 'Rubik, sans-serif',
        '--font-size': '0.875rem',
        '--border-radius': '4px',
        '--rgb-accent': '31, 76, 92',
        maxHeight: 'calc(var(--100vh) - 173px)',
    },
});

const LANGUAGE_TO_LOCALE = {
    [LANGUAGE.ENGLISH]: 'en',
    [LANGUAGE.UKRAINIAN]: 'uk',
    [LANGUAGE.PORTUGUESE]: 'pt',
    [LANGUAGE.SPANISH]: 'es',
};

const LOCALE_DATA = { en, es, pt, uk };

const EmojiPicker = ({ element, anchorEl, onClose, onEmojiSelect, placement = 'top-start', dynamicWidth = false }) => {
    const language = useSelector(state => state.auth.user?.language);
    const i18nDict = LOCALE_DATA[LANGUAGE_TO_LOCALE[language]] || en;

    const handleEmojiSelect = emoji => onEmojiSelect(emoji);

    return (
        <>
            {element}
            <Popper
                open={!!anchorEl}
                anchorEl={anchorEl}
                placement={placement}
                sx={{ padding: 0, width: anchorEl?.clientWidth || 'auto' }}
            >
                <ClickAwayListener onClickAway={onClose} mouseEvent="onMouseDown" touchEvent="onTouchStart">
                    <PickerWrapper>
                        <Picker
                            data={data}
                            onEmojiSelect={handleEmojiSelect}
                            i18n={i18nDict}
                            previewPosition="none"
                            skinTonePosition="none"
                            emojiButtonSize={30}
                            emojiSize={22}
                            maxFrequentRows={2}
                            perLine={9}
                            theme="light"
                            dynamicWidth={dynamicWidth}
                        />
                    </PickerWrapper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default EmojiPicker;
